import { useState, useEffect } from 'react';
import permissionCheck from '../components/Layout/permissionCheck';
import { useSelector } from 'react-redux';
import RootState from '../redux/states/root.state';

const usePermissionCheck = (permissionsToCheck: string[], ignoreImpersonation?:boolean): any => {
    const {data:user} = useSelector((state: RootState) => state.user);
    const [canAccess, setCanAccess] = useState(false);
    const [checking, setChecking] = useState(true);


    useEffect(() => {
        if (!user) return;
        setCanAccess(permissionCheck(user,permissionsToCheck))
        setChecking(false);
    }, [ignoreImpersonation, user, permissionsToCheck]);

    return {canAccess, checking};
};

export default usePermissionCheck;
